import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Button } from "../../components/ui/button"
import { Badge } from "../ui/badge"
import {
  Clock,
  Stethoscope,
  Microscope,
  Star,
  ChevronRight,
} from "lucide-react"

export default function Aboutuswidget() {

  const [data, setData] = useState(null)

  useEffect(() => {
    fetch("/wp-json/custom/v1/about")
      .then(res => res.json())
      .then(res => setData(res))
  }, [])

 const getIcon = (icon) => {
  const value =
    typeof icon === "object" ? icon.value : icon?.toLowerCase()

  switch (value) {
    case "clock":
      return <Clock className="w-4 h-4 mr-1" />
    case "stethoscope":
      return <Stethoscope className="w-4 h-4 mr-1" />
    case "microscope":
      return <Microscope className="w-4 h-4 mr-1" />
    case "star":
      return <Star className="w-4 h-4 mr-1" />
    default:
      return null
  }
}

  if (!data) return null

  return (
    <section className="py-12 bg-gray-100">
      <div className="container px-4 mx-auto">
        <div className="flex flex-col items-center max-w-3xl mx-auto text-center">

          <Badge className="mb-4">About Us</Badge>

          <h2 className="mb-4 text-3xl font-bold md:text-4xl">
            {data.title}
          </h2>

          <p className="mb-6 text-lg text-muted-foreground">
            {data.description}
          </p>

          <div className="flex flex-wrap justify-center gap-4 mt-2">
           {data.features?.map((item, index) => (
            <Badge key={index} variant="outline" className="px-3 py-1">
              {getIcon(item.icon)}
              {item.text}
            </Badge>
          ))}
          </div>

          <Button variant="link" className="mt-6 gap-2 text-primary" asChild>
            <Link to={data.button_link || "/about"}>
              {data.button_text || "Learn More About Us"}
              <ChevronRight className="w-4 h-4" />
            </Link>
          </Button>

        </div>
      </div>
    </section>
  )
}